import { exists } from '@/api'

export interface InspectionOfflineCheckTest {
  scanCount: number
  checkCount: number
  foundCount: number
  branchDifferentCount: number
  shelfTypeDifferentCount: number
  unregisteredCount: number
  illegalStateCount: number
  receiveWaitingCount: number
  ngNumbers: number[]
}

export const defaultInspectionOfflineCheckTest = (): InspectionOfflineCheckTest => ({
  scanCount: 0,
  checkCount: 0,
  foundCount: 0,
  branchDifferentCount: 0,
  shelfTypeDifferentCount: 0,
  unregisteredCount: 0,
  illegalStateCount: 0,
  receiveWaitingCount: 0,
  ngNumbers: []
})

export function InspectionOfflineCheckTestFromJSON(
  json: any
): InspectionOfflineCheckTest {
  return {
    scanCount: exists(json, 'scan_count') ? json.scan_count : 0,
    checkCount: exists(json, 'check_count') ? json.check_count : 0,
    foundCount: exists(json, 'found_count') ? json.found_count : 0,
    branchDifferentCount: exists(json, 'branch_different_count')
      ? json.branch_different_count
      : 0,
    shelfTypeDifferentCount: exists(json, 'shelf_type_different_count')
      ? json.shelf_type_different_count
      : 0,
    unregisteredCount: exists(json, 'unregistered_count')
      ? json.unregistered_count
      : 0,
    illegalStateCount: exists(json, 'illegal_state_count')
      ? json.illegal_state_count
      : 0,
    receiveWaitingCount: exists(json, 'receive_waiting_count')
      ? json.receive_waiting_count
      : 0,
    ngNumbers: exists(json, 'ng_numbers') ? json.ng_numbers : []
  }
}
